import React from "react";
import { Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  quote: "Eagle Exteriors replaced our roof after a bad storm. The team was professional, kept us informed throughout, and worked with our insurance company every step of the way.",
  name: "Sarah Jenkins",
  role: "Homeowner | Minneapolis"
}, {
  quote: "The siding replacement completely transformed our home's curb appeal. They were efficient, clean, and the quality of the craftsmanship is evident in every detail.",
  name: "Michael Thompson",
  role: "Property Manager | St. Paul"
}, {
  quote: "I was impressed by their honesty. They could have sold me a full roof replacement, but they recommended a simple repair that saved me thousands. Highly recommend.",
  name: "David Miller",
  role: "Homeowner | Bloomington"
}, {
  quote: "Professional from start to finish. Their gutter installation was quick and they used high-quality materials that have held up perfectly through several heavy rains.",
  name: "Amanda Rogers",
  role: "Real Estate Agent | Edina"
}];
export default function Testimonials() {
  return <section data-section-id="253681" id="testimonials" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {testimonials.map((testimonial, i) => <Card key={i} data-index={i} className="bg-card border-border rounded-md shadow-md hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-8 md:p-10 flex flex-col h-full justify-between relative">
                <Quote className="absolute top-8 right-8 w-12 h-12 text-primary-500 opacity-10 rotate-180" strokeWidth={1} />
                
                <div className="mb-10 relative z-10">
                  <p className="text-base md:text-lg italic text-muted-foreground font-sans leading-relaxed">
                    "{testimonial.quote}"
                  </p>
                </div>
                
                <div className="mt-auto">
                  <div className="w-full border-t border-dashed border-border mb-6"></div>
                  <p className="font-default font-bold text-primary-500 text-sm uppercase tracking-wide">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-muted-foreground font-sans mt-1">
                    {testimonial.role}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>
        
        <p className="text-sm text-muted-foreground italic font-sans max-w-4xl">
          Verified reviews from homeowners and property managers who trust Eagle Exteriors for their roofing, siding, and gutter needs across the Twin Cities.
        </p>
      </div>
    </section>;
}